import { render, staticRenderFns } from "./AppSaFooter.vue?vue&type=template&id=a484e816&scoped=true&lang=pug&"
import script from "./AppSaFooter.vue?vue&type=script&lang=js&"
export * from "./AppSaFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppSaFooter.vue?vue&type=style&index=0&id=a484e816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a484e816",
  null
  
)

export default component.exports